import type { TypeActe as CleTypeActe } from '@/types';

import COLORS from './colors';
import { TYPES_ACTES_IMPLEMENTES } from './typesActesImplementes';

export interface TypeActe {
  key: string;
  text: string;
  /** Libellé au singulier, accentué : badge du type dans les listes. */
  libelle: string;
  value: string;
  icon: string;
  statsColor: string;
  textColor: string;
}

const TYPES_ACTES: TypeActe[] = [
  {
    key: 'naissance',
    libelle: 'Naissance',
    text: 'Naissances',
    value: 'naissance',
    icon: 'Baby',
    statsColor: COLORS.LightBlueCardColor,
    textColor: COLORS.BlueTextColor,
  },
  {
    key: 'reconnaissance',
    libelle: 'Reconnaissance',
    text: 'Reconnaissances',
    value: 'reconnaissance',
    icon: 'UserCheck',
    statsColor: COLORS.GreenCardColor,
    textColor: COLORS.GreenTextColor,
  },
  {
    key: 'mariage',
    libelle: 'Mariage',
    text: 'Mariages',
    value: 'mariage',
    icon: 'Heart',
    statsColor: COLORS.PinkCardColor,
    textColor: COLORS.PinkTextColor,
  },
  {
    key: 'deces',
    libelle: 'Décès',
    text: 'Décès',
    value: 'deces',
    icon: 'Cross',
    statsColor: COLORS.LightGreyCardColor,
    textColor: COLORS.GreyTextColor,
  },
  {
    key: 'decision',
    libelle: 'Décision',
    text: 'Décisions',
    value: 'decision',
    icon: 'BookmarkCheck',
    statsColor: COLORS.MarinBlueCardColor,
    textColor: COLORS.MarinBlueTextColor,
  },
  {
    key: 'pacs',
    libelle: 'PACS',
    text: 'PACS',
    value: 'pacs',
    icon: 'Users',
    statsColor: COLORS.PurpleCardColor,
    textColor: COLORS.PurpleTextColor,
  },
  {
    key: 'mention',
    libelle: 'Mention',
    text: 'Mentions',
    value: 'mention',
    icon: 'FileText',
    statsColor: COLORS.OrangeCardColor,
    textColor: COLORS.OrangeTextColor,
  },
];

export const TYPES_ACTES_OPTIONS = [
  { key: 'all', text: 'Tous les types', value: '' },
  ...TYPES_ACTES.map(({ key, text, value }) => ({ key, text, value })),
];

/**
 * Types montrés par le tableau de bord : ceux dont la numérisation est livrée,
 * et les mentions. Pacs et décisions attendent la v2 de l'application.
 */
export const TYPES_ACTES_TABLEAU_DE_BORD = TYPES_ACTES.filter(
  ({ key }) =>
    key === 'mention' || TYPES_ACTES_IMPLEMENTES.includes(key as CleTypeActe),
);

export default TYPES_ACTES;
